export default __webpack_public_path__ + "static/media/x-lg.3ad82eb6.svg";